<script lang="ts">
  import type { Stripe } from "@stripe/stripe-js";

  import { CardCvc, CardExpiry, CardNumber } from "svelte-stripe";
  import Container from "svelte-stripe/Container.svelte";
  import { navigate } from "svelte-navigator";

  export let clientSecret = null;
  export let stripe: Stripe = null;

  let processing = false;
  let cardElement;

  let error = null;

  async function submit() {
    // avoid processing duplicates
    if (processing) return;
    processing = true;
    error = null;
    // create the payment intent server-side
    // confirm payment with stripe
    const result = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {},
      },
    });
    processing = false;

    // log results, for debugging
    console.log({ result });
    if (result.error) {
      // payment failed, notify user
      error = result.error.message;
    } else {
      // payment succeeded, redirect to "thank you" page
      alert("Payment method added successfully!");
      navigate("/");
    }
  }
</script>

<div class="wrapper">
  <h2>Step 2 - Credit Card Details</h2>
  {#if stripe}
    <Container {stripe}>
      <form on:submit|preventDefault={submit}>
        <CardNumber bind:element={cardElement} classes={{ base: "input" }} />
        <div class="row">
          <CardExpiry classes={{ base: "input" }} />
          <CardCvc classes={{ base: "input" }} />
        </div>
        <button disabled={processing}>
          {#if processing}
            Processing...
          {:else}
            Add Payment Method
          {/if}
        </button>
      </form>
    </Container>
  {:else}
    Loading...
  {/if}

  {#if error}
    <div class="error">Error: {error}</div>
  {/if}
</div>

<style>
  .error {
    padding: 2em;
    color: #ffe100;
    font-size: 1.2em;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 2rem 0;
    background-color: white;
    padding: 2em;
  }
  .row {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
  .row :global(.input) {
    width: 20%;
  }

  .wrapper {
    margin: 20px;
    padding: 10px;
    background-color: var(--color-bg);
  }
</style>
